import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1IjoibW92ZWNyZWF0aXZlIiwiYSI6ImNseXpqYzB2eDI5ZWoyaXNobHBwdXZpYm0ifQ.X9E0EZ6Ls0P9vK7ns4waVg';



 $('.js-map-part').each(function(){
	let block = $(this)
	let map
	let locations = []
	const categoryCheckboxes = block.find('.element-checkbox input')

	block.find('.js-location').each(function(){
		let location = {
			lat: $(this).data('lat'),
			lng: $(this).data('lng'),
			icon: $(this).data('icon'),
			html: $(this).data('text'),
		}
		locations.push(location)
	})


	// Initialize map
	map = new mapboxgl.Map({
	    container: $(this).find('.js-map')[0],
	    //style: 'mapbox://styles/mapbox/outdoors-v12',
	    style: 'mapbox://styles/movecreative/clz1fnn7400jk01nv7neu09ud',
	    center: [locations[0]['lng'], locations[0]['lat']],
	    zoom: 6
	});



	// Function to add markers to the map
	function addMarkers(filteredObjects) {
	    // Clear existing markers
	    const markers = document.getElementsByClassName('marker');
	    while(markers[0]) {
	        markers[0].parentNode.removeChild(markers[0]);
	    }

	    // Add new markers
	    filteredObjects.forEach(object => {
	        const el = document.createElement('div');
	        el.className = 'marker';
	        el.style.backgroundImage = `url(${object.icon})`;
	        el.style.width = '34px';
	        el.style.height = '46px';
	        el.style.backgroundSize = '100%';

	        let newMarker = new mapboxgl.Marker(el)
	           
          if (object.lng && object.lat){
          	const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(object.html);

          	newMarker.setLngLat([object.lng, object.lat]).setPopup(popup).addTo(map);
          }
	    });
	}

	// Initial load of all locations
	addMarkers(locations);

})








// import {Loader} from '@googlemaps/js-api-loader';

// const loader = new Loader({
//     apiKey: "AIzaSyA12YKF7xJd8gsNMs_8luTksixUWWMIAAU",
// });


                

// $('.js-map-part').each(function(){
// 	let block = $(this)
// 	let map
// 	let markers = []
// 	let locations = []

// 	block.find('.js-location').each(function(){
// 		let location = {
// 			text: $(this).data('text'),
// 			location: { 
// 				lat: $(this).data('lat'),
// 				lng: $(this).data('lng'),
// 			},
// 			icon: $(this).data('icon'),
// 		}
// 		locations.push(location)
// 	})




// 	//--- load map after google loaded scripts

// 	loader.load().then((google) => {

// 	    map = new google.maps.Map(block.find('.js-map')[0], {
// 	        center: { lat: 57.030165, lng: 24.422982 },
// 	        zoom: 7
// 	    });

// 	    addMarkers(locations);
// 	})

// 	function addMarkers(locations) {

// 	    locations.forEach(location => {
	    	
// 	        const marker = new google.maps.Marker({
// 	            position: location.location,
// 	            map: map,
// 	            title: '',
// 	            icon: location.icon,
// 	        });

// 	        markers.push(marker);

// 	        let infowindow = new google.maps.InfoWindow({
// 		        content: location.text
// 		      });

// 	        marker.addListener('click', function() {
// 		        infowindow.open(map, marker);
// 		      });
// 	    });

// 	}

// })

